import editTour from './editTour';
import changeDayType from './changeDayType';
import addAssignment from './addAssignment';
import editAssignment from './editAssignment';
import addDayOffRequest from './addDayOffRequest';

const loadItemData = {
  editTour,
  changeDayType,
  addAssignment,
  editAssignment,
  addDayOffRequest
};

export default loadItemData;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/loadItemData/index.js